module.exports = __webpack_public_path__ + "static/media/dolby-atmos.f5b3a8e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/appletv-icons/dolby-atmos.svg
// module id = 254
// module chunks = 0